import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MembersAccountRoutingModule } from './members.account.routing.module';

import { MemberStickyNoteComponent } from './components/member.sticky.note/member.sticky.note.component';

import { MemberProfileComponent } from './member.profile/member.profile.component';
import { ProfileOverviewComponent } from './components/profile.overview/profile.overview.component';

import { SharedAppModule } from '../app.module.shared';
import { SoftwareLicensesComponent } from './components/software.licenses/software.licenses.component';
import { CreditCardListComponent } from './components/credit.card.list/credit.card.list.component';
import { MemberActivityStreamComponent } from './components/member.activity.stream/member.activity.stream.component';
import { MemberNotesComponent } from './components/member.notes/member.notes.component';
import { NoteListComponent } from './components/member.notes/note.list/note.list.component';
import { MemberTicketsComponent } from './components/member.tickets/member.tickets.component';
import { MemberGisComponent } from './components/member.gis/member.gis.component';
import { MemberRecurringChargesComponent } from './components/member.recurring.charges/member.recurring.charges.component';
import { MemberInvoicesComponent } from './components/member.invoices/member.invoices.component';
import { MemberCreditsComponent } from './components/member.credits/member.credits.component';
import { MemberEmailComponent } from './components/member.email/member.email.component';
import { TOSComponent } from './components/tos/tos.component';
import { MemberLogsComponent } from './components/member.logs/member.logs.component';
import { MemberTrainingComponent } from './components/member.training/member.training.component';
import { MemberOrphanComponent } from './components/member.orphans/member.orphans.component';
import { MemberFilesComponent } from './components/member.files/member.files.component';
import { MemberMembershipsComponent } from './components/member.memberships/member.memberships.component';

@NgModule({
    declarations: [
        MemberProfileComponent,
        ProfileOverviewComponent,
        SoftwareLicensesComponent,
        CreditCardListComponent,
        MemberActivityStreamComponent,
        MemberNotesComponent,
        NoteListComponent,
        MemberTicketsComponent,
        MemberGisComponent,
        MemberRecurringChargesComponent,
        MemberInvoicesComponent,
        MemberEmailComponent,

        MemberCreditsComponent,
        MemberStickyNoteComponent,
        MemberLogsComponent,
        MemberMembershipsComponent,
        MemberTrainingComponent,
        MemberOrphanComponent,
        MemberFilesComponent,

        TOSComponent,

    ],
    exports: [
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,
        MembersAccountRoutingModule
    ]
})
export class MemberAccountModule { }
